export default {
  'app.pwa.offline': 'Bạn hiện đang ngoại tuyến',
  'app.pwa.serviceworker.updated': 'Nội dung mới đã sẵn sàng',
  'app.pwa.serviceworker.updated.hint':
    'Vui lòng nhấn nút "Làm mới" để tải lại trang hiện tại',
  'app.pwa.serviceworker.updated.ok': 'Làm mới',
};
